// extracted by mini-css-extract-plugin
export default {"root":"I8zzfL","girlIcon":"m1P6Tv","title":"T2pHJw","action":"hScv0m"};